
import { useShopSelection } from '../useShopSelection';
import { useShopsData } from './useShopsData';
import { ShopFilterHookReturn } from './types';
import { useEffect } from 'react';

export const useShopFilter = (): ShopFilterHookReturn => {
  const {
    isSingleSelectionMode,
    toggleSelectionMode,
    selectedShops,
    singleSelectedShop,
    setSingleSelectedShop,
    toggleShopSelection,
    getSelectedShopIds,
    clearFilters,
    isInitialized
  } = useShopSelection();

  const {
    shops,
    isLoading,
    isCollapsed,
    setIsCollapsed,
    filteredShops,
    searchTerm,
    setSearchTerm,
    refreshShops
  } = useShopsData();

  // Select the first shop by default when shops are loaded and no shop is selected
  useEffect(() => {
    // Only run this effect if we've already initialized from localStorage
    // and we're not still loading shops
    if (isInitialized && !isLoading && shops.length > 0 && !singleSelectedShop) {
      // No shop is selected yet, select the first shop by default
      console.log('Selecting first shop by default:', shops[0].id);
      setSingleSelectedShop(shops[0].id);
    }
  }, [isLoading, shops, singleSelectedShop, setSingleSelectedShop, isInitialized]);

  return {
    // Shop selection functionality
    isSingleSelectionMode,
    toggleSelectionMode,
    selectedShops,
    singleSelectedShop,
    setSingleSelectedShop,
    toggleShopSelection,
    getSelectedShopIds,
    clearFilters,

    // Shop data functionality
    shops,
    isLoading,
    isCollapsed,
    setIsCollapsed,
    filteredShops,
    searchTerm,
    setSearchTerm,
    refreshShops
  };
};

// Export sub-hooks for more granular usage
export { useShopSelection } from '../useShopSelection';
export { useShopsData } from './useShopsData';
export * from './types';
